<template lang="slm">
.container
  .columns.is-multiline
    .column.is-8.is-offset-2.is-7-widescreen
      .content
        .GoogleForm
    	   iframe :src="url + '?embedded=true'" frameborder="0" marginheight="0" marginwidth="0" style="width: 100%; height:500px" Laster skjema...
</template>

<script>
export default {
  props: ['url']
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/GoogleFormBlock.vue